<!--海森介绍-->
<template>
  <div id='not-found' class="not-found">
    <div class="pic"><img class="pic-img" src="static/404/404.png"/></div>
    <div @click="toHome" class="back-home">返回首页</div>
    <div class="text">页面走丢了...
      非常抱歉，您所请求的页面不存在！
      请仔细检查您输入的网址是否正确。
    </div>
  </div>
</template>

<script>

export default {

  data() {
    return {
    };
  },

  methods: {
    toHome() {
      this.$router.push('/home');
    },

  },
}
</script>

<style scoped>
.not-found {
  background-color: #00AFEC;
  width: 1920px;
  height: 930px;
  text-align: center;
  overflow: hidden;
  color: white;
}

.pic {
  margin-top: 100px;
  height: 500px;
  line-height: 500px;
}
.pic-img{
  width: 700px;
  height: 400px;
}
.back-home {
  font-size: 20px;
  margin-left: 892px;
  width: 150px;
  height: 40px;
  line-height: 40px;
  border: white 1px solid;
  border-radius: 5px;
}
.back-home:hover {
  cursor: pointer;
}
.text{
  height: 100px;
  line-height: 100px;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/NotFound.vue